import * as c from "./config.constant"
import {ConfigState} from "./config.reducer"

export const setOutletId = (payload: string) => ({
    type: c.SET_OUTLET_ID,
    payload
})

export const setConfig = (payload: ConfigState) => ({
    type: c.SET_BATCH_CONFIG,
    payload
})